<div class="tw-mt-5 tw-flex tw-justify-center" *ngIf="loading">
  <div>
    <p class="tw-text-center">
      <bit-icon
        name="bwi-spinner"
        class="bwi-spin bwi-2x tw-text-muted"
        [ariaLabel]="'loading' | i18n"
      ></bit-icon>
    </p>
  </div>
</div>
<div *ngIf="!loading && !authed">
  <p bitTypography="body1" class="tw-text-center">
    {{ name }}
  </p>
  <p bitTypography="body1">{{ "acceptEmergencyAccess" | i18n }}</p>
  <hr />
  <div class="tw-flex tw-gap-2">
    <a
      bitButton
      buttonType="primary"
      routerLink="/login"
      [queryParams]="{ email: email }"
      [block]="true"
    >
      {{ "logIn" | i18n }}
    </a>
    <button type="button" bitButton buttonType="primary" (click)="register()" [block]="true">
      {{ "createAccount" | i18n }}
    </button>
  </div>
</div>
